import React, { useState } from 'react'
import { motion } from 'framer-motion'
import { useNavigate } from 'react-router-dom'

const DevelopmentProcess = ({ data }) => {


    const [activeItem, setactiveItem] = useState(data.processInfo[0])
    const [animate, setanimate] = useState({ opacity: [0, 1] })

    const navigate = useNavigate()

    const handleClick = (item) => {
        setanimate({ opacity: [1, 0] })

        setTimeout(() => {
            setanimate({ opacity: [0, 1] })
            setactiveItem(item)
        }, 400);
    }

    return (
        <div className='max-w-screen-2xl mx-auto py-5 md:py-8 px-4 md:px-12'>
            <div>
                <h1
                    className='text-xl md:text-2xl font-bold text-center dark:text-white'
                >
                    {data.title1}
                </h1>
                <h1
                    className='text-xl md:text-2xl font-bold text-center text-yellow-500'
                >
                    {data.title2}
                </h1>
                <div className='flex justify-center my-2'>
                    <p className='text-center text-[15px] md:max-w-[700px] dark:text-white'>
                        {data.desc}
                    </p>
                </div>
            </div>

            <div className='grid grid-cols-1 md:grid-cols-3 mt-7 md:mt-11 gap-5 xl:gap-0 md:pb-8 '>
                <div className='relative'>
                    {data.processInfo.map((item, i) => (
                        <div key={i} className='flex items-center justify-end gap-5 py-2 cursor-pointer' onMouseEnter={() => handleClick(item)}>

                            <h1 className={`text-right transition-all duration-300 w-max font-bold text-sm ${activeItem.title === item.title && i === 0 ? 'text-red-500 ' : activeItem.title === item.title && i === 1 ? 'text-yellow-500' : activeItem.title === item.title && i === 2 ? 'text-blue-500' : activeItem.title === item.title && i === 3 ? 'text-pink-500' : activeItem.title === item.title && i === 4 ? 'text-purple-500' : activeItem.title === item.title && i === 5 ? 'text-green-500' : 'dark:text-white'}`}>
                                {item.title}
                            </h1>
                            <div className={`h-[8px] w-[8px] relative dark:z-30 transition-all duration-300 rounded-full ${activeItem.title === item.title && i === 0 ? 'bg-red-500' : activeItem.title === item.title && i === 1 ? 'bg-yellow-500' : activeItem.title === item.title && i === 2 ? 'bg-blue-500' : activeItem.title === item.title && i === 3 ? 'bg-pink-500' : activeItem.title === item.title && i === 4 ? 'bg-purple-500' : activeItem.title === item.title && i === 5 ? 'bg-green-500' : 'bg-gray-300'}`} />
                        </div>
                    ))}
                    <div className='absolute py-[23px]  h-full w-[1px] right-[3.5px] top-0  -z-30 dark:z-0' >
                        <div className='bg-gray-300 dark:bg-gray-400 w-full h-full ' />
                    </div>

                </div>
                <div className='col-span-2 w-[90%] mx-auto md:w-full flex justify-center'>
                    <motion.div
                        whileInView={animate}
                        transition={{ duration: 1.0, delay: 0.1 }}
                        viewport={{ once: false }}
                    >
                        <div
                            onClick={() => navigate(activeItem.link)}
                            className='bg-white shadow-xl cursor-pointer dark:bg-gray-800 sm:w-[600px] hover:scale-105 duration-1000 h-full rounded-xl px-3 md:px-5 py-7 md:py-5'>
                            <div className='flex flex-col transition-all duration-1000 justify-center items-center h-full'>
                                <img src={activeItem.img} alt="img" className='object-contain h-[80px]' />
                                <h1 className='font-bold text-base md:text-base text-center mt-2 dark:text-white'>
                                    {activeItem.title}
                                </h1>
                                <p className='text-xs mt-3 text-gray-500 dark:text-gray-300'>
                                    {activeItem.desc}
                                </p>
                            </div>
                        </div>
                    </motion.div>
                </div>
            </div>

        </div >
    )
}

export default DevelopmentProcess